import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { BSModal } from '~/components/Bootstrap';
import { ServicesContext } from '~/services';

export function InAppCountSettings() {
    const servicesContext = React.useContext(ServicesContext);
    const { savedNotificationOptions } = servicesContext.user.getSavedSearchData();
    const storedEnabled = React.useRef((savedNotificationOptions?.app?.openTA as boolean) || false);
    const [show, setShow] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [enabled, setEnabled] = React.useState(
        (savedNotificationOptions?.app?.openTA as boolean) || false
    );

    async function save() {
        setLoading(true);
        await servicesContext.user.setSavedSearchData('notification_options', {
            ...savedNotificationOptions,
            app: {
                openTA: enabled,
            },
        });
        setLoading(false);
        storedEnabled.current = enabled;
        setShow(false);
    }

    function cancel() {
        setEnabled(storedEnabled.current);
        setShow(false);
    }

    return (
        <div className="row align-items-center mt-2">
            <div className="col-3 text-end">
                <div>In App Count</div>
            </div>
            <div className="col-3">{storedEnabled.current ? 'Enabled' : 'Disabled'}</div>
            <div className="col-6 text-end text-nowrap">
                <button className="btn btn-primary" type="button" onClick={() => setShow(true)}>
                    Options
                </button>
                <BSModal show={show} onHide={cancel} aria-labelledby="in-app-count-settings-modal">
                    <Modal.Header closeButton>
                        <Modal.Title id="in-app-count-settings-modal" role="heading" aria-level={1}>
                            In App Count
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mb-1">Show me counts when:</div>
                        <label className="form-label align-baseline">
                            <input
                                type="checkbox"
                                className="align-middle"
                                checked={enabled}
                                onChange={(e) => setEnabled(e.target.checked)}
                            />
                            <span className="ms-2">
                                There is an open Timely Action Reminder
                                <i className="fa-regular fa-clock ms-1" />
                            </span>
                        </label>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" onClick={cancel}>
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={save}
                            disabled={loading}
                        >
                            {loading && (
                                <Spinner
                                    animation="border"
                                    className="me-1"
                                    role="status"
                                    size="sm"
                                    variant="light"
                                />
                            )}
                            Save
                        </button>
                    </Modal.Footer>
                </BSModal>
            </div>
        </div>
    );
}
